import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNumber1Circle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"number-1-circle"} maskId="square-filled-radius-0-stroke-1-IconNumber1Circle"><path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM11.9844 7.77246L9.73438 9.38965V10.5029L11.8848 8.94434H11.9785V16.2275H13.0332V7.77246H11.9844Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconNumber1Circle;
